import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=0adc428b"
import script from "./Access.vue?vue&type=script&lang=ts"
export * from "./Access.vue?vue&type=script&lang=ts"
import style0 from "./Access.vue?vue&type=style&index=0&id=0adc428b&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports